import { render } from "./ScrollDownButton.vue?vue&type=template&id=74148160&scoped=true"
import script from "./ScrollDownButton.vue?vue&type=script&lang=js"
export * from "./ScrollDownButton.vue?vue&type=script&lang=js"

import "./ScrollDownButton.vue?vue&type=style&index=0&id=74148160&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74148160"]])

export default __exports__